<template>
<div></div>
</template>

<script>
export default {
  name: "Step8Component"
}
</script>

<style scoped>

</style>